const id_whs_itemstock = {
    "": "stok barang",
    detail: "detail stok barang",
    req_in: "Req. masuk",
    req_out: "Req. keluar",

    label: {
        available: "tersedia",
        low: "sedikit",
        out_of_stock: "habis",
        stock_detail: "lihat detail stok",
        stock_status: "status stok",
        stock_closing: "stok akhir"
    },
}

export default id_whs_itemstock;